import { Card, Column, Row } from "@components/Layout";
import { Button, Image } from "@kobalte/core";
import { A } from "@solidjs/router";
import { styled } from "solid-styled-components";

export const TracklistImage = styled(Image.Root)`
  height: 140px;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  & > * {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 1024px) {
    height: 80px;
  }
`;
export const TracklistHeaderColumn = styled(Column)`
  max-width: calc(100% - 160px);
  @media only screen and (max-width: 1024px) {
    max-width: calc(100% - 100px);
  }
`;

export const ProgrammeName = styled.h1`
  font-size: 25px;
  padding: 0 10px 10px 0;
  @media only screen and (max-width: 1024px) {
    font-size: 20px;
  }
`;
export const UserLink = styled(A)`
  width: max-content;
`;
export const BookmarkButton = styled(Button.Root)`
  border: none;
  background: none;
  cursor: pointer;
`;

export const AuthorRow = styled(Row)`
  @media only screen and (max-width: 1024px) {
    font-size: 13px;
    padding: 5px 0;
  }
  @media only screen and (max-width: 756px) {
    & > div:first-of-type {
      flex-direction: column;
      gap: 5px;
    }
  }
`;

export const AuthorImageColumn = styled(Column)`
  width: 50px;
  height: 50px;
  @media only screen and (max-width: 1024px) {
    width: 25px;
    height: 25px;
  }
`;

export const CategoriesRow = styled(Row)`
  overflow: auto hidden;
`;

export const CategoryPill = styled(Row)`
  border-radius: 11px;
  border: 1px solid ${({ theme }) => theme?.colors.accentTertiary};
`;

export const DesktopHeaderCard = styled(Card)`
  @media only screen and (max-width: 512px) {
      display: none;
  }
`;
